import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { useDateSegment } from "react-aria";
//#region src/DatePicker/components/DateSegment.tsx
const DateSegment = ({ segment, state, size, onClick }) => {
	const rootRef = React.useRef(null);
	const { segmentProps } = useDateSegment(segment, state, rootRef);
	return /* @__PURE__ */ jsxs("div", {
		"data-cy": "dateField-div-tasktracker",
		...segmentProps,
		className: cn("focus:bg-system-info-50 focus:text-neutrals-white focus:outline-neutrals-80 group box-content rounded-md px-px text-right tabular-nums outline outline-1 -outline-offset-1 outline-transparent", segment.isEditable ? "text-neutrals-30" : "text-neutrals-50"),
		ref: rootRef,
		style: {
			...segmentProps.style,
			minWidth: segment.maxValue != null ? String(segment.maxValue).length : void 0
		},
		onClick,
		children: [/* @__PURE__ */ jsx("span", {
			"aria-hidden": "true",
			className: cn("text-type-light pointer-events-none block w-full text-center group-focus:text-black", !segment.isPlaceholder && "invisible h-0", size === "sm" ? "text-sm" : "text-base"),
			children: segment.placeholder
		}), segment.isPlaceholder ? "" : /* @__PURE__ */ jsx("div", {
			className: "text-center",
			children: segment.text
		})]
	});
};
//#endregion
export { DateSegment as default };

//# sourceMappingURL=DateSegment.js.map